export default {
      Products: '$MHF_ModelNameVal_$MHF|Products',

};
